<template>
    <div>
        <template
            v-if="!readonly"
        >

            <rkm-row>
                <rkm-col cols="12">
                    <template>
                        <template v-if="data.model.prescricaoMedicamentos.length > 0">
                            <rkm-button
                                v-if="data.model.prescricaoMedicamentos.length === data.model.prescricaoMedicamentos.filter(m => !!m.checked).length"
                                @click="unselectAll"
                                color="primary"
                                class="print-button"
                            >
                                Desmarcar todos
                            </rkm-button>

                            <rkm-button
                                v-else
                                @click="selectAll"
                                color="primary"
                                class="print-button"
                            >
                                Selecionar todos
                            </rkm-button>
                        </template>

                        <rkm-button
                            @click="$refs.Modal.open()"
                            color="primary"
                            class="print-button"
                        >
                            Adicionar prescrição de medicamento
                        </rkm-button>

                        <rkm-button
                            v-if="data.model.prescricaoMedicamentos.filter(medicamento => !!medicamento.checked && medicamento.material && medicamento.material.receitaTipoId == enums.tipoReceita.COMUM && !medicamento.isRemoverImpressao).length > 0"
                            @click="print(enums.tipoReceita.COMUM, false)"
                            color="info"
                            class="print-button"
                        >
                            Imprimir receita comum
                        </rkm-button>

                        <rkm-button
                            v-if="data.model.prescricaoMedicamentos.filter(medicamento => !!medicamento.checked && medicamento.material && medicamento.material.receitaTipoId == enums.tipoReceita.ESPECIAL && !medicamento.isRemoverImpressao).length > 0"
                            @click="print(enums.tipoReceita.ESPECIAL, false)"
                            color="info"
                            class="print-button"
                        >
                            Imprimir receita especial
                        </rkm-button>

                        <rkm-button
                            v-if="data.model.prescricaoMedicamentos.filter(medicamento => !!medicamento.checked && medicamento.material && medicamento.material.receitaTipoId == enums.tipoReceita.ESPECIAL_AZUL && !medicamento.isRemoverImpressao).length > 0"
                            @click="print(enums.tipoReceita.ESPECIAL_AZUL, false)"
                            color="info"
                            class="print-button"
                        >
                            Imprimir receita especial azul
                        </rkm-button>

                        <rkm-button
                            v-if="data.model.prescricaoMedicamentos.filter(medicamento => !!medicamento.checked && medicamento.material && medicamento.material.receitaTipoId == enums.tipoReceita.ESPECIAL_AMARELA && !medicamento.isRemoverImpressao).length > 0"
                            @click="print(enums.tipoReceita.ESPECIAL_AMARELA, false)"
                            color="info"
                            class="print-button"
                        >
                            Imprimir receita especial amarela
                        </rkm-button>

                        <rkm-button
                            v-if="data.model.prescricaoMedicamentos.filter(medicamento => !!medicamento.checked && medicamento.isManual && medicamento.receitaTipoId == enums.tipoReceita.COMUM).length > 0"
                            @click="print(enums.tipoReceita.COMUM, true)"
                            color="info"
                            class="print-button"
                        >
                            Imprimir receita não padronizada comum
                        </rkm-button>

                        <rkm-button
                            v-if="data.model.prescricaoMedicamentos.filter(medicamento => !!medicamento.checked && medicamento.isManual && medicamento.receitaTipoId == enums.tipoReceita.ESPECIAL).length > 0"
                            @click="print(enums.tipoReceita.ESPECIAL, true)"
                            color="info"
                            class="print-button"
                        >
                            Imprimir receita não padronizada especial
                        </rkm-button>
                    </template>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <List :data="data" />
                </rkm-col>
            </rkm-row>
        </template>

        <rkm-row v-else>
            <rkm-col cols="12">
                <List
                    :data="data"
                    :readonly="readonly"
                />
            </rkm-col>
        </rkm-row>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import List from './List'
import Modal from './Modal'

// Enums.
import tipoReceita from '@/enums/cadastro/medicamento/tipoReceita'

// Vuex.
import {mapActions} from 'vuex'

// Mixins.
import {error, file, repository, stringCase} from '@/mixins'

export default {
    components: {
        List,
        Modal,
    },
    created() {
        this.repositories = {
            pdf: this.getConectaSusRepository('impressao.ambulatorio'),
        }
    },
    data: () => ({
        enums: {
            tipoReceita
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        selectAll() {

            this.data.model.prescricaoMedicamentos.map(m => this.$set(m, 'checked', true))
        },
        unselectAll() {

            this.data.model.prescricaoMedicamentos.map(m => this.$set(m, 'checked', false))
        },
        print(tipoReceita, isManual) {

            const item = {
                emAtendimento: true,
                atendimentoId: this.data.additionals.atendimentoId,
                multiple: true,
                medicamentos: isManual
                    ? this.data.model.prescricaoMedicamentos.filter(medicamento => !!medicamento.checked && medicamento.isManual && medicamento.receitaTipoId == tipoReceita)
                    : this.data.model.prescricaoMedicamentos.filter(medicamento => !!medicamento.checked && medicamento.material && medicamento.material.receitaTipoId == tipoReceita)
            };

            let request = null

            if (isManual) {
                if (tipoReceita == this.enums.tipoReceita.ESPECIAL) {
                    request = this.repositories.pdf.receitaMedicaNaoPadronizadaEspecial(this.data.additionals.paciente.id, this.camelObjectKeysToSnakeRecursive(item))
                } else {
                    request = this.repositories.pdf.receitaMedicaNaoPadronizadaComum(this.data.additionals.paciente.id, this.camelObjectKeysToSnakeRecursive(item))
                }
            } else if (tipoReceita == this.enums.tipoReceita.ESPECIAL) {
                request = this.repositories.pdf.receitaMedicaEspecial(this.data.additionals.paciente.id, this.camelObjectKeysToSnakeRecursive(item))
            } else if (tipoReceita == this.enums.tipoReceita.ESPECIAL_AMARELA) {
                request = this.repositories.pdf.receitaMedicaEspecialAmarela(this.data.additionals.paciente.id, this.camelObjectKeysToSnakeRecursive(item))
            } else if (tipoReceita == this.enums.tipoReceita.ESPECIAL_AZUL) {
                request = this.repositories.pdf.receitaMedicaEspecialAzul(this.data.additionals.paciente.id, this.camelObjectKeysToSnakeRecursive(item))
            } else {
                request = this.repositories.pdf.receitaMedicaComum(this.data.additionals.paciente.id, this.camelObjectKeysToSnakeRecursive(item))
            }

            this.setLoading()

            request
                .then(({data, headers}) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, file, repository, stringCase],
    props: {
        data: {type: Object, required: true},
        readonly: {type: Boolean, default: false},
    },
}
</script>

<style scoped>
.print-button {
    margin-left: 0px!important;
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
}
</style>